// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"1b8d2cde","621":"22dd23de","843":"31d6cfe0","856":"fa908b25"}[chunkId] + ".chunk.css";
};